<template>
    <main class="library flex flex-column">
        <primary-navigation />
        <div class="ff library-empty" v-if="empty">
            <div class="constrain bc">
                <h1 class="center bc">Redeem an access code to start your exploration.</h1>
                <div class="flex flex-center">
                    <div class="button" @click="redeem">Redeem a Product Code</div>
                </div>
            </div>
            <div class="library-graphic"></div>
        </div>
    </main>
</template>

<script>
    import Redeem from '@/components/modals/Redeem.vue';

    export default {
        name: 'Library',
        data(){
            return {
                code: '',
                empty: false
            };
        },
        created(){
            if(this.$store.getters.product){
                this.$router.push({name: 'product.contents', params: {product: this.$store.getters.product.product_slug}});
            }else if(this.$store.getters.products.length){
                this.$store.dispatch('products/activate')
                .then(() => {
                    this.$router.push({name: 'product.contents', params: {product: this.$store.getters.product.product_slug}});
                });
            }else{
                this.empty = true;
            }
        },
        methods: {
            redeem(){
                this.$modal.show(Redeem, {}, {
                    width: 320,
                    height: 'auto',
                    classes: 'modal'
                });
            }
        },
        computed: {
            products(){
                return this.$store.getters.products; 
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .library
    {
        min-height: 100vh;
    }

    .library-empty
    {
        .constrain
        {
            z-index: 5;
            padding-top: 150px;
        }
    }

    .library-graphic
    {
        height: 60%;
        background: url('~@/assets/earth.jpg') top center no-repeat;
        background-size: cover;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    header
    {
        margin-bottom: 14px;
    }

    h1
    {
        max-width: 600px;
        margin-bottom: 50px;
        color: @f;
    }

    [theme="dark"]
    {
        .library
        {
            background: @black;
        }
    }
</style>